import { Track } from "@/src/lib/tracking";

/** 本设备当日的要数据槽状态（EDG-591 US1）：按「用户 + 本地日历日」隔离 */
export interface ConnectSlotDailyState {
  clickedToday: boolean;
  rotationIndex: number;
}

const STORAGE_KEY_PREFIX = "connect_slot_daily";
const EMPTY_STATE: ConnectSlotDailyState = {
  clickedToday: false,
  rotationIndex: 0,
};

interface StoredState extends ConnectSlotDailyState {
  date: string;
}

/** 本地日历日 YYYY-MM-DD（PRD A.3「以用户本地日历日为界」） */
export const toLocalDateKey = (date: Date = new Date()): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

const storageKey = (userId: string): string =>
  `${STORAGE_KEY_PREFIX}:${userId}`;

export function readConnectSlotDaily(
  userId: string,
  now: Date = new Date(),
): ConnectSlotDailyState {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) {
      return EMPTY_STATE;
    }
    const stored = JSON.parse(raw) as Partial<StoredState>;
    if (stored.date !== toLocalDateKey(now)) {
      return EMPTY_STATE;
    }
    return {
      clickedToday: stored.clickedToday === true,
      rotationIndex: Number.isFinite(stored.rotationIndex)
        ? Number(stored.rotationIndex)
        : 0,
    };
  } catch (error) {
    Track.log("warn", "chat_connect_slot", "read daily state failed", {
      error: String(error),
    });
    return EMPTY_STATE;
  }
}

export function writeConnectSlotDaily(
  userId: string,
  state: ConnectSlotDailyState,
  now: Date = new Date(),
): void {
  try {
    const stored: StoredState = { ...state, date: toLocalDateKey(now) };
    localStorage.setItem(storageKey(userId), JSON.stringify(stored));
  } catch (error) {
    Track.log("warn", "chat_connect_slot", "write daily state failed", {
      error: String(error),
    });
  }
}
